import MyBatchAddVehicleInfoBusinessNoteModal from './my-batch-add-vehicle-info-business-note-modal.vue'
export default MyBatchAddVehicleInfoBusinessNoteModal
